// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#os
export enum OsList {
  Mac = 'Macintosh',
  Windows = 'Windows',
  Linux = 'Linux',
  Unknown = 'Unknown',
}

export const identifyCurrentOs = (): OsList => {
  const { userAgent } = window.navigator;

  if (userAgent.includes(OsList.Mac)) {
    return OsList.Mac;
  }
  if (userAgent.includes(OsList.Windows)) {
    return OsList.Windows;
  }
  if (userAgent.includes(OsList.Linux)) {
    return OsList.Linux;
  }

  return OsList.Unknown;
};
